import React, { useContext } from 'react'

import { DELIVERY_TRUCK_ICON } from '../../../constants/urls'
import { DataContext } from '../../../context/DataContext'
import { formatDate } from '../../../utils/dates'

const DeliveryState: React.FC = () => {
  const { sale } = useContext(DataContext)

  const date = formatDate(new Date(sale?.promisedDeliveryDate))

  return (
    <div className='mt-6 flex items-center gap-4 justify-center bg-[#F7F7F7] p-4 rounded-xl'>
      <div>
          <img src={`${DELIVERY_TRUCK_ICON}`} alt='delivery truck' />
      </div>
      <div>
          <h1 className='font-[Geist] text-lg font-medium'>Tu pedido llega</h1>
          <p className='font-[Geist] text-sm text-gray-500'>{date}</p>
      </div>
    </div>
  )
}

export default DeliveryState
